/**
 * PJ – Bundle-Angebot im Warenkorb-Drawer: Groessenwahl + Direkt-Hinzufuegen.
 *
 * Bewusst eine eigene Asset-Datei statt eines <script> im Snippet:
 * Horizon rendert den Drawer-Inhalt nach (Cart-Updates ersetzen das Markup),
 * und dabei fuehrt der Browser eingebettete <script>-Tags NICHT aus. Ein
 * inline-Skript liefe deshalb entweder nie oder nur beim allerersten Aufbau.
 *
 * Daher: delegierte Klick-Handler auf document (ueberleben jeden Austausch)
 * + MutationObserver, der die Groessen-Vorauswahl auf frisch eingefuegtem
 * Markup nachzieht.
 *
 * Markup kommt aus snippets/pj-cart-bundle-hint.liquid.
 */
(function () {
  var SEL_BOX = '[data-pj-bundle]';
  var SEL_SIZE = '[data-pj-bundle-size]';
  var SEL_ADD = '[data-pj-bundle-add]';

  function alleGroessen(box) {
    return Array.prototype.slice.call(box.querySelectorAll(SEL_SIZE));
  }

  function waehle(box, btn) {
    if (!btn || btn.disabled) return;
    alleGroessen(box).forEach(function (b) {
      b.classList.toggle('is-selected', b === btn);
    });
    var addBtn = box.querySelector(SEL_ADD);
    if (addBtn) addBtn.disabled = false;
  }

  /**
   * Vorschlag: dieselbe Groesse wie das Teil, das schon im Warenkorb liegt.
   * Nur wenn es diese Groesse beim anderen Teil gibt UND sie lieferbar ist —
   * sonst bleibt bewusst nichts vorgewaehlt, statt still etwas Falsches
   * vorzuschlagen. Der Kunde kann immer frei umwaehlen.
   */
  function setzeVorauswahl(box) {
    if (box.dataset.pjVorauswahl === '1') return;
    box.dataset.pjVorauswahl = '1';

    var vorschlag = (box.getAttribute('data-vorschlag') || '').trim().toUpperCase();
    if (!vorschlag) return;

    var treffer = alleGroessen(box).filter(function (b) {
      return b.getAttribute('data-size') === vorschlag && !b.disabled;
    })[0];

    if (treffer) waehle(box, treffer);
  }

  function initAlle() {
    Array.prototype.slice.call(document.querySelectorAll(SEL_BOX)).forEach(setzeVorauswahl);
  }

  /** Drawer-Inhalt neu holen, statt die Seite neu zu laden. */
  function drawerAktualisieren() {
    return fetch(window.location.pathname, { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var neu = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
        var alt = document.querySelector('.cart-drawer__inner');
        if (neu && alt) {
          alt.replaceWith(neu);
          initAlle();
        } else {
          window.location.reload();
        }
      });
  }

  document.addEventListener('click', function (ev) {
    var sizeBtn = ev.target.closest ? ev.target.closest(SEL_SIZE) : null;
    if (sizeBtn) {
      var box1 = sizeBtn.closest(SEL_BOX);
      if (box1) waehle(box1, sizeBtn);
      return;
    }

    var addBtn = ev.target.closest ? ev.target.closest(SEL_ADD) : null;
    if (!addBtn || addBtn.disabled) return;

    var box = addBtn.closest(SEL_BOX);
    if (!box) return;

    var gewaehlt = box.querySelector(SEL_SIZE + '.is-selected');
    if (!gewaehlt) return;

    var msg = box.querySelector('[data-pj-bundle-msg]');
    var alterText = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Wird hinzugefügt…';
    if (msg) { msg.textContent = ''; msg.className = 'pj-cart-bundle__msg'; }

    // Merkt sich, ob der Artikel bereits im Warenkorb gelandet ist. Scheitert
    // danach nur das Neuladen des Drawers, darf der Button NICHT wieder
    // aktiviert werden — sonst legt ein zweiter Klick denselben Artikel
    // ein zweites Mal in den Warenkorb.
    var bereitsHinzugefuegt = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(gewaehlt.getAttribute('data-variant-id')), quantity: 1 }]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        bereitsHinzugefuegt = true;
        return r.json();
      })
      .then(drawerAktualisieren)
      .catch(function () {
        if (bereitsHinzugefuegt) {
          // Artikel liegt im Warenkorb, nur die Anzeige hinkt hinterher.
          window.location.reload();
          return;
        }
        addBtn.disabled = false;
        addBtn.textContent = alterText;
        if (msg) {
          msg.textContent = 'Hat nicht geklappt. Bitte nochmal versuchen.';
          msg.className = 'pj-cart-bundle__msg is-err';
        }
      });
  });

  // Vorauswahl auch auf Markup nachziehen, das Horizon nachtraeglich einsetzt.
  // Scope so eng wie moeglich: nur der Warenkorb-Drawer, nicht die ganze Seite.
  var beobachter = new MutationObserver(function () { initAlle(); });

  function start() {
    initAlle();
    var ziel = document.querySelector('cart-drawer-component') || document.body;
    beobachter.observe(ziel, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
